const breakpoints = Object.freeze({
  mobile: 0,
  tablet: 768,
  desktop: 1278,
})

export default breakpoints
